//generic reducer for app level
import {
  FETCH_REQUEST,
  FETCH_SUCCESS,
  FETCH_FAILED,
  GET_TM_METADATA_REQUEST,
  GET_TM_METADATA_SUCCESS
} from '../actions/app';

const initialState = {
  isFetching: false,
  isFetched: false,
  payload: null
};

export default function app(state = initialState, action) {
  switch (action.type) {
    case FETCH_REQUEST:
      return {
        ...state,
        isFetching: true,
        ...action.payload
      };
    case FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        ...action.payload
      };
    case FETCH_FAILED:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        ...action.payload
      };
    case GET_TM_METADATA_REQUEST:
      return {
        ...action.payload
      };
    case GET_TM_METADATA_SUCCESS:
      return {
        ...state,
        tmMetadataResp: {
          ...action.payload
        }
      };
    default:
      return state;
  }
}
